<template>
  <el-row
      v-gutter="gutter"
      type="flex"
      align="middle">
    <div class="gj-alert--icon"
         :style="{'font-size': iconFontSize}">
      <i :class="['el-icon-' + type]" :style="{'color': iconColor}"></i>
    </div>
    <div class="gj-alert--text"
         :style="{'font-size': fontSize, color: fontColor}">
      <slot></slot>
    </div>
  </el-row>
</template>

<script>
  export default {
    name: "gj-text-alert",
    props: {
      type: {
        type: String,
        default: 'success',
        validator: function (value) {
          return ['success', 'warning', 'error','info'].indexOf(value) !== -1
        }
      },
      iconFontSize: {
        type: String,
        default: '16px'
      },
      fontSize: {
        type: String,
        default: '12px'
      },
      fontColor: {
        type: String,
        default: '#333',
      },
      gutter: {
        type: Number,
        default: 8
      },
      iconColor: {
        type: String,
        default: null
      }
    }
  }
</script>

<style scoped>
  .gj-alert--icon {
    font-size: 25px;
    line-height: 1;
    color: #ED6A0C;
  }
  .gj-alert--text {
    font-size: 12px;
  }
  .el-icon-error {
    color: #F56C6C
  }
  .el-icon-info {
    color: #1F6EEF;
  }
</style>
